"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { RxChevronRight } from "react-icons/rx";

export function Layout195() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2 lg:gap-x-20">
          <div className="order-2 md:order-1">
            <img
              src="/images/layouts/conversation-hub.png"
              className="w-full object-cover"
              alt="Relume placeholder image"
            />
          </div>
          <div className="order-1 md:order-2">
            <p className="mb-3 font-semibold md:mb-4">Thinking</p>
            <h2 className="mb-5 text-5xl font-bold md:mb-6 md:text-7xl lg:text-8xl">
              Your ideas stop disappearing
            </h2>
            <p className="mb-6 md:mb-8 md:text-md">
              Your best thinking lives in conversations—especially AI
              conversations with ChatGPT, Claude, Gemini, Grok, and Perplexity.
              IntegrateWise brings those scattered conversations into one
              searchable Second Brain.
            </p>
            <div className="grid grid-cols-1 gap-6 py-2 sm:grid-cols-2">
              <div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                  Revisit ideas
                </h6>
                <p>
                  Return to your thinking whenever you need it, refined and
                  ready.
                </p>
              </div>
              <div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                  Connect thinking
                </h6>
                <p>
                  Link ideas across tools and time to see patterns you'd
                  otherwise miss.
                </p>
              </div>
            </div>
            <div className="mt-6 flex flex-wrap gap-4 md:mt-8">
              <Button variant="secondary">Discover</Button>
              <Button iconRight={<RxChevronRight />} variant="link" size="link">
                Arrow
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
